export default __webpack_public_path__ + "static/media/lounge.964b6fa4.jpg";